<template>
  <div class="d-flex ga-2 w-100">
    <DpplNewButton
      class="w-50"
      color="primary"
      size="small"
      :disabled="disabled"
      @click="$emit('share-via-email')"
    >
      {{ shareViaEmailText }}
    </DpplNewButton>
    <DpplNewButton
      class="w-50"
      color="primary"
      size="small"
      variant="outlined"
      @click="emit('copy-report-link')"
    >
      Copy Report Link
    </DpplNewButton>
  </div>
</template>

<script setup>
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  shareViaEmailText: {
    type: String,
    default: 'Share via Email',
  },
});

const emit = defineEmits(['copy-report-link', 'share-via-email']);
</script>
